var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{loading: _vm.loader},attrs:{"id":"app"}},[(_vm.loader)?_c('spinner'):_vm._e(),_c('sidebar'),_c('main',{staticClass:"main"},[_c('head-menu'),_c('router-view')],1),_c('main-menu'),_c('search'),_c('modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }